import React from "react";
import { useNavigate } from "react-router-dom";
import { Animate } from "react-simple-animate";
import "./styles.scss";

const backgroundVideo = "video.mp4";

const Home = () => {
  const navigate = useNavigate();

  const goToNaats = () => {
    navigate("/naat");
  };

  return (
    <section className="home">
      {/* Background Video or Image */}
      <div className="hero">
        <video autoPlay loop muted className="hero-video">
          <source src={backgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="overlay"></div>
        <div className="hero-content">
          <Animate
            play
            duration={1.5}
            delay={0.5}
            start={{ opacity: 0, transform: "translateY(-50px)" }}
            end={{ opacity: 1, transform: "translateY(0px)" }}
          >
             <div className="bismillah">بِسْمِ ٱللَّٰهِ الرَّحْمَٰنِ الرَّحِيمِ</div>
            <h1>ASSALAM O ALAIKUM</h1>
            <p className="text-home">Listen to heartwarming Naats & Qawalis</p>
            <button onClick={goToNaats}>Explore Naats</button>
          </Animate>
        </div>
      </div>
    </section>
  );
};

export default Home;
